<template>
  <notes
    description="General Notes related to this Partner"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    supplier: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "supplier"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.supplier.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
